// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"Spinner__Spinner__1fiyk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 341
// module chunks = 3